<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3bCqBK/tc-custom/9781611520323.jpg?1723592038590" alt="This image is the cover for the book Runes of the Quest"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Runes of the Quest
      </h1>
      <p class="bookDescription body article font2">
        <p>As a child, Morlea's handmaid wove wondrous tales to amuse her. Among these stories was the legend of Talitha, a princess like Morlea herself, trapped in a tower whose walls wept at her unjust imprisonment. An evil wizard hid her away until a prince could save her, then struck the land and its people barren to prevent any attempt at rescue.<br/><br/>Morlea believes the story nothing more than a fantasy until, years later, she discovers a possible location for the fabled tower. Dissatisfied with palace life and looking for adventure, she decides to chase down Talitha on her own.<br/><br/>A princess needs to be rescued, of course. And if there aren't any able-bodied princes up to the task, why can't another princess be the savior for once?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J.T. Marie
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8919de58